import React from 'react';
import './index.css';
import Header from './Header';
import Main from './Main';
import Footer from './Footer';

const App = () => (
  <div className="App">
    <Header />
    <Main />
    <Footer />
  </div>
);

export default App;